export enum ResearchTeamMemberAccessStatusEnum {
    Pending = 'Pending',
    Granted = 'Granted',
    Denied = 'Denied',
}
